import React from 'react'

import { t } from 'src/translations'

import { SearchIcon } from './SearchIcon'

type SearchBoxProps = {
  value: string
  onValueChange: (value: string) => void
  placeholder?: string
  className?: string
  inputClassName?: string
  id?: string
  dataTestId?: string
  ariaLabel?: string
  ariaLabelledBy?: string
  ariaDescribedBy?: string
  maxLength?: number
  inputRef?: React.RefObject<HTMLInputElement>
  onFocus?: () => void
  onBlur?: () => void
  onKeyDown?: (e: React.KeyboardEvent) => void
}

export const SearchBox = ({
  value,
  onValueChange,
  placeholder,
  className,
  inputClassName,
  id,
  dataTestId,
  ariaLabel,
  ariaLabelledBy,
  ariaDescribedBy,
  maxLength = 100,
  inputRef,
  onFocus,
  onBlur,
  onKeyDown = () => {}
}: SearchBoxProps) => {
  return (
    <div className={className}>
      <div className='searchIcon'>
        <i className='inline-block leading-none' aria-hidden='true'>
          <SearchIcon />
        </i>
      </div>

      <input
        ref={inputRef}
        className={inputClassName}
        type='text'
        value={value}
        onChange={(e) => onValueChange(e.target.value)}
        placeholder={placeholder}
        data-testid={dataTestId}
        role='searchbox'
        id={id}
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        aria-describedby={ariaDescribedBy}
        maxLength={maxLength}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={(e) => {
          onKeyDown(e)
          if (e.code === 'Enter' || e.key === 'Enter') {
            e.preventDefault()
            e.currentTarget.blur()
          }
        }}
      />

      <ClearIcon value={value} onClick={() => onValueChange('')} />
    </div>
  )
}

const ClearIcon = ({
  onClick,
  value
}: {
  onClick: () => void
  value: string
}) => {
  if (!value) {
    return <div className='searchClearIconPlaceHolder'></div>
  }

  return (
    <div className='searchClearIcon'>
      <button type='button' onClick={onClick}>
        <i role='img' aria-label={t('search-input.aria-label.clear')}>
          <svg
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='none'
            className='inline-block align-middle h-6 w-6'
          >
            <path
              fillRule='evenodd'
              clipRule='evenodd'
              // eslint-disable-next-line max-len
              d='M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75zM9.78 8.72a.75.75 0 00-1.06 1.06L10.94 12l-2.22 2.22a.75.75 0 101.06 1.06L12 13.06l2.22 2.22a.75.75 0 101.06-1.06L13.06 12l2.22-2.22a.75.75 0 00-1.06-1.06L12 10.94 9.78 8.72z'
              fill='currentColor'
            ></path>
          </svg>
        </i>
      </button>
    </div>
  )
}
